<template>
  <div>
    <div class="section-header">
      <h3>ESG</h3>
      <div class="text-overline mx-4">
        <ColorScaledScore :score="fmtNum(summary.total, 0)" />
      </div>
    </div>
    <Chart :options="chartOptions"></Chart>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive } from "vue"
import Chart, { type Options } from "@wbim/highcharts-themed"

import ColorScaledScore from "@/components/common/ColorScaledScore.vue"
import { fmtNum } from "@/utils/vmMethods.js"
import { CorpEsgApi } from "@/views/corpEsg/api"

const props = defineProps<{ issuer: string }>()
const api = new CorpEsgApi()

const summary = reactive({
  total: 0,
  environmental: 0,
  social: 0,
  governance: 0
})

const chartOptions = computed<Options>(() => {
  return {
    chart: { type: "column", height: 360 },
    legend: { enabled: false },
    xAxis: {
      type: "category",
      categories: ["Overall", "Environmental", "Social", "Governance"]
    },
    yAxis: { title: { text: "Score" }, max: 100 },
    tooltip: { enabled: false },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          style: {
            color: "#ccc",
            fontSize: "16px"
          },
          format: "{y:.0f}"
        }
      }
    },
    series: [
      {
        type: "column",
        data: [summary.total, summary.environmental, summary.social, summary.governance]
      }
    ]
  }
})

onMounted(async () => {
  const result = await api.getEsgSummaryFromLegacy(props.issuer)
  summary.total = result.score
  summary.environmental = result.environmental
  summary.social = result.social
  summary.governance = result.governance
})
</script>
